import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { CardActionArea } from '@material-ui/core';

const RequestActionButton = (props) => {
  const { actionMessage, icon, action, signetSignal } = props || {};

  const cardActionAreaStyle = signetSignal
    ? 'action-button-signet'
    : 'action-button';

  const colStyle = signetSignal
    ? 'action-button-signet-width'
    : 'action-button-width';

  return (
    <Col md={2} onClick={action} className={`${colStyle}`}>
      <CardActionArea className={`${cardActionAreaStyle}`}>
        <Row className="mt-2 action-icon-center ">{icon}</Row>

        <Row className="mt-2 text-center action-button-message">
          {actionMessage}
        </Row>
      </CardActionArea>
    </Col>
  );
};

export default RequestActionButton;
